// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./magaele/bt_slbx/css.scss
// module id = 73
// module chunks = 2